const privateCompliantId = "PRIVATE";
export default function getCompliantAppId(id: string | undefined | null, providerName: string | undefined | null, typeString: string | undefined | null): string | undefined | null {
    return IsPrivateAddin(providerName, typeString) ? privateCompliantId : id;
}

export function getCompliantAppName(name: string | undefined | null, providerName: string | undefined | null, typeString: string | undefined | null): string | undefined | null {
    return IsPrivateAddin(providerName, typeString) ? privateCompliantId : name;
}

//This function is a duplicate of function present in osfruntime, this is done to avoid dependency on osfruntime to decrease the package size.
export function IsPrivateAddin(exchangeExtensionProviderName: string | undefined | null, exchangeExtensionType: string | undefined | null): boolean {
    // When compliance metadata is absent, we cannot determine privacy status.
    // Default to private to avoid exposing sensitive information.
    if (exchangeExtensionProviderName == null && exchangeExtensionType == null) {
        return true;
    }
    var extensionTypeLowerCase = exchangeExtensionType != null ? exchangeExtensionType.toLowerCase() : null;
    if (extensionTypeLowerCase === "default" ||
        extensionTypeLowerCase === "marketplace" ||
        extensionTypeLowerCase === "preinstalled" ||
        extensionTypeLowerCase === "marketplaceprivatecatalog") {
        return false;
    }
    var providerNameLowercase = exchangeExtensionProviderName != null ? exchangeExtensionProviderName.toLowerCase() : null;
    if (providerNameLowercase === "microsoft" ||
        providerNameLowercase === "microsoft corp" ||
        providerNameLowercase === "microsoft corp." ||
        providerNameLowercase === "microsoft corporation") {
        return false;
    }
    return true;
}
